import { render, staticRenderFns } from "./TagGrid.vue?vue&type=template&id=41413990&"
import script from "./TagGrid.vue?vue&type=script&lang=js&"
export * from "./TagGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports